import React from 'react';
import SnackbarManager from '@CommonFunctionalDisplay/GlobalSnackbar/SnackbarManager';

class ErrorHandler extends React.Component {

    constructor(props) {

        super(props);

    }

    handleError(err) {
        const message = err?.response?.data?.message || err?.message || 'Something went wrong';
        SnackbarManager.show(
            message,
            'error'
        );
    }

    logError(resource, err) {
        console.error("Error in Loading Resource", resource);
        console.error(err);
    }
}

export default ErrorHandler;
